<div>
    <div class="container">

        <h1 style="text-align:center">{{ 'Pacchetti turistici convenzionati' | translate }}</h1>

        <div class="img-top" *ngIf="true">
            <img src="assets/img/golf.jpg" />
        </div>

        <!-- se ha abilitato la visualizzazione dei pacchetti -->
        <ng-container *ngIf="app.appstore.C2">


            <div class="row biglietto" *ngIf="!pacchetti || pacchetti.length === 0">
                <div class="col-12" style="min-height: 150px; display: flex; justify-content: center; align-items: center;">
                    {{ 'Nessun pacchetto disponibile' | translate }}
                </div>
            </div>

            <div class="row biglietto fadeInUp animated" *ngFor="let pac of pacchetti; let i = index">
                <!--  [ngClass]="getClass(i+1)" -->
                <div *ngIf="titolo(pac) && pac.C[0]" class="col-md-4 img-pacchetto" [style.background-image]="sanitizeImage(pac.Thumb)"></div>
                <div *ngIf="titolo(pac) && pac.C[0]" class="col-md-8 p-20">
                    <h3 [innerHTML]="titolo(pac) | safeHtml"></h3>
                    <p style="color: #555;" [innerHTML]="descrizione(pac) | safeHtml"></p>
                    <p style="color: #555;margin-top: 15px">Prezzo a partire da <strong>{{ pac.N[0] | currency:'EUR' }}</strong>
                    </p>
                    <p style="color: #555;">
                        <ng-container *ngIf="pac.D[0] && pac.D[1]">
                            Offerta valida dal <strong>{{ pac.D[0].toFormat('dd/MM/yyyy')}}</strong> al
                            <strong>{{ pac.D[1].toFormat('dd/MM/yyyy')}}</strong>
                        </ng-container>
                        <ng-container *ngIf="pac.D[0] && !pac.D[1]">
                            Offerta valida dal <strong>{{ pac.D[0].toFormat('dd/MM/yyyy')}}</strong>
                        </ng-container>
                        <ng-container *ngIf="!pac.D[0] && pac.D[1]">
                            Offerta valida fino al <strong>{{ pac.D[1].toFormat('dd/MM/yyyy')}}</strong>
                        </ng-container>
                    </p>

                    <button mat-button class="container-buy-button shop-button shop-button-label" (click)="getMoreInfo(pac, i)">
                        <span class="shop-button-label" *ngIf="!pac.isSelected">{{ 'Maggiori informazioni' | translate }}</span>
                        <span class="shop-button-label" *ngIf="pac.isSelected">{{ 'Meno informazioni' | translate }}</span>
                    </button>
                </div>

                <div [ngStyle]="getStyle(pac.isSelected)" style="overflow: hidden; transition: all ease .5s" *ngIf="hotels && hotels[i] && hotels[i].hotel && pac.C[0]">
                    <div class="mt-20">
                        <h1 style="text-align: center;">{{ hotels[i].hotel.title }}</h1>
                    </div>
                    <ng-container *ngIf="hotels[i].gallery">
                        <ng-container *ngIf="hotels[i].gallery.length >= 3">
                            <div class="row">
                                <div class="col-12 col-sm-4" style="padding: 0;">
                                    <div class="d-none d-sm-block" style="padding-right: 15px">
                                        <div class="img-gallery" style="width: 100%; height: 200px; margin-bottom: 15px;" [style.background-image]="sanitizeImage(hotels[i].gallery[1].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                        <div class="img-gallery" style="width: 100%; height: 200px;" [style.background-image]="sanitizeImage(hotels[i].gallery[2].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                    </div>
                                    <div class="d-flex d-sm-none" style="padding: 0">
                                        <div class="img-gallery" style="width: 50%; height: 100px; margin-bottom: 15px; margin-right: 5px;" [style.background-image]="sanitizeImage(hotels[i].gallery[1].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                        <div class="img-gallery" style="width: 50%; height: 100px; margin-left: 5px;" [style.background-image]="sanitizeImage(hotels[i].gallery[2].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-8" style="padding: 0">
                                    <div class="d-none d-sm-block img-gallery" style="width: 100%; height: 415px; position: relative;" [style.background-image]="sanitizeImage(hotels[i].gallery[0].URL)" (click)="openGalleryDialog(hotels[i])">
                                        <div *ngIf="hotels[i].gallery.length > 3" class="other-photos">Altre {{ hotels[i].gallery.length - 3}} foto</div>
                                    </div>
                                    <div class="d-block d-sm-none img-gallery" style="width: 100%; height: 200px; position: relative;" [style.background-image]="sanitizeImage(hotels[i].gallery[0].URL)" (click)="openGalleryDialog(hotels[i])">
                                        <div *ngIf="hotels[i].gallery.length > 3" class="other-photos">Altre {{ hotels[i].gallery.length - 3}} foto</div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="hotels[i].gallery.length == 2">
                            <div class="row px-20">
                                <div class="col-7" style="padding-right: 15px">
                                    <div class="img-gallery" style="width: 100%; height: 200px; margin-bottom: 15px;" [style.background-image]="sanitizeImage(hotels[i].gallery[0].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                </div>
                                <div class="col-5" style="padding-left: 0">
                                    <div class="img-gallery" style="width: 100%; height: 200px; position: relative;" [style.background-image]="sanitizeImage(hotels[i].gallery[1].URL)" (click)="openGalleryDialog(hotels[i])">
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="hotels[i].gallery.length == 1">
                            <div class="row px-20">
                                <div class="col-12" style="padding-right: 15px">
                                    <div class="img-gallery" style="width: 100%; height: 200px; margin-bottom: 15px;" [style.background-image]="sanitizeImage(hotels[i].gallery[0].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="hotels[i].hotel">
                        <div class="row px-20 my-20">
                            <div class="col-12 col-sm-6 mb-20" style="line-height: 2;">
                                <h5 class="mb-30">Contatti</h5>
                                <!-- <div>{{ hotels[i].hotel.company }}</div> -->
                                <div>
                                    {{ hotels[i].hotel.address }}{{ ', ' + hotels[i].hotel.city }}{{ ' (' + hotels[i].hotel.province + ')' }}{{ ' - ' + hotels[i].hotel.zip }}
                                </div>
                                <div><a [href]="hotels[i].hotel.website">{{ hotels[i].hotel.website }}</a></div>
                                <div>Email: {{ hotels[i].hotel.email }}</div>
                                <div>Telefono: {{ hotels[i].hotel.phone }}</div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <h5>Richiedi informazioni per:<br />{{ titolo(pac) }}</h5>
                                <mat-form-field class="full-width" style="max-width: 400px">
                                    <mat-label>Nome (*)</mat-label>
                                    <input matInput [(ngModel)]="prenotaNome" (change)="checkForm(false)">
                                </mat-form-field>
                                <mat-form-field class="full-width" style="max-width: 400px">
                                    <mat-label>Email (*)</mat-label>
                                    <input matInput [(ngModel)]="prenotaEmail" (change)="checkForm(false)">
                                </mat-form-field>
                                <mat-form-field class="full-width" style="max-width: 400px">
                                    <mat-label>Cellulare</mat-label>
                                    <input matInput [(ngModel)]="prenotaMobile">
                                </mat-form-field>

                                <mat-form-field class="full-width" style="max-width: 400px">
                                    <mat-label>Messaggio</mat-label>
                                    <textarea matInput [(ngModel)]="prenotaTesto" (change)="checkForm(false)" style="min-height: 60px;"></textarea>
                                </mat-form-field>

                                <!-- TODO: alex -->
                                <!-- aggiungere checkbox privacy default: https://opengolf.it/it/privacy-policy -->
                                <!-- captcha -->
                                <!-- aggiungere campo "Pacchetto" inserendo il nome del pacchetto sopra -->

                                <div class="mb-5" *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</div>

                                <button mat-button class="container-buy-button shop-button shop-button-label" (click)="inviaHotel(hotels[i].hotel.username, titolo(pac) )" style="float: none">
                  <span class="shop-button-label">{{ 'general.send' | translate }}</span>
                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

        </ng-container>

        <!-- altrimenti, se non ha abilitato la visualizzazione dei pacchetti, visualizzo il form di richiesta info -->
        <ng-container *ngIf="!app.appstore.C2">

            <!-- <div class="logo">
                      <img *ngIf="store" [src]="utils.imageLogo(store)" />
                  </div> -->

            <div class="biglietto mt-20 p-30">

                <div class="row px-20 my-20">

                    <div class="col-12 col-sm-6 mb-20" style="line-height: 2;" *ngIf="app.curruser">
                        <h5 class="mb-30">Contatti</h5>
                        <div>{{ app.curruser.company }}</div>
                        <div>
                            {{ app.curruser.address }}{{ ', ' + app.curruser.city }}{{ ' (' + app.curruser.province + ')' }}{{ ' - ' + app.curruser.zip }}
                        </div>
                        <div>Web: <a [href]="'https://' + app.curruser.website">{{ app.curruser.website }}</a></div>
                        <div>Email: {{ app.curruser.email }}</div>
                        <div>Telefono: {{ app.curruser.phone }}</div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <h5>Richiedi informazioni</h5>
                        <p class="mb-30">Vuoi ricevere delle proposte di pacchetti turistici convenzionati al golfclub?</p>

                        <mat-form-field class="full-width" style="max-width: 400px">
                            <mat-label>Nome Cognome *</mat-label>
                            <input matInput [(ngModel)]="prenotaNome" (change)="checkForm(false)">
                        </mat-form-field>

                        <div class="row">
                            <div class="col-sm-6" style="max-width: 200px">
                                <mat-form-field class="full-width" style="max-width: 400px">
                                    <mat-label>Email *</mat-label>
                                    <input matInput [(ngModel)]="prenotaEmail" (change)="checkForm(false)">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-6" style="max-width: 200px">
                                <mat-form-field class="full-width" style="max-width: 400px">
                                    <mat-label>Cellulare</mat-label>
                                    <input matInput [(ngModel)]="prenotaMobile" (change)="checkForm(false)">
                                </mat-form-field>
                            </div>
                        </div>

                        <mat-form-field class="full-width" style="max-width: 400px">
                            <mat-label>Messaggio</mat-label>
                            <textarea matInput [(ngModel)]="prenotaTesto" (change)="checkForm(false)" style="min-height: 60px;"></textarea>
                        </mat-form-field>

                        <re-captcha #recaptcha (resolved)="resolved($event)" siteKey="6Le7lvYhAAAAAMeOWm5GTZmchc_lsdum6kZvYnkv">
                        </re-captcha>

                        <mat-checkbox class="mt-20 mb-10" [(ngModel)]="privacy" color="primary" (change)="checkForm(false)" style="font-size: .9rem">
                            {{ 'login.privacy1' | translate }}
                            <span class="link" (click)="openUrl('')">{{ 'login.privacy' | translate }}</span> {{ 'login.privacy2' | translate }}
                        </mat-checkbox>

                        <div class="mt-15" style="width: 100%; display: flex; flex-direction: column;">
                            <div class="mb-5" *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</div>
                            <button style="width: 100px;" mat-button class="container-buy-button shop-button shop-button-label" (click)="invia()">
                <span class="shop-button-label">{{ 'Invia' | translate }}</span>
              </button>
                        </div>

                    </div>
                </div>

            </div>
        </ng-container>

        <app-credits [configApp]="app" *ngIf="app"></app-credits>

        <div style="clear: both;margin-bottom:50px"></div>
    </div>
</div>